import React from 'react';
import './Pages/PagesCss/PrivacyPolicy.css';

const About = () => {

  const values = [
    {
      icon: "fa-solid fa-bullseye",
      title: "Educational Focus",
      description: "We prioritize learning over selling. Our tools are designed to educate, not to provide financial advice."
    },
    {
      icon: "fa-solid fa-magnifying-glass",
      title: "Transparency",
      description: "We clearly explain our calculation methods and assumptions. No hidden agendas, no confusing jargon."
    },
    {
      icon: "fa-solid fa-book",
      title: "Accessibility",
      description: "Complex financial concepts explained in simple terms. From beginners to experts, everyone can learn."
    },
    {
      icon: "fa-solid fa-rotate-right",
      title: "Continuous Improvement",
      description: "We regularly update our tools based on user feedback and the latest financial methodologies."
    }
  ];

  const milestones = [
    { year: "2024", title: "Foundation", description: "noobtobull founded to simplify financial education." },
  { year: "2025", title: "First Calculators", description: "Launched initial 10 calculators." },
  { year: "2025", title: "User Growth", description: "Reached 50,000 monthly users worldwide." },
  { year: "2025", title: "Platform Expansion", description: "Expanded to 25+ calculators and educational content." },
  ];

  return (
    <div className="privacy-policy">
      {/* Header Section */}
      <section className="policy-header">
        <div className="container">
          <div className="header-content">
            <h1>About noobtobull</h1>
            <p className="header-description">
              Empowering financial literacy with innovative calculators and easy-to-understand resources. 
  From beginners to advanced learners, we're here to guide your journey.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-grid">
            {/* Quick Navigation */}
            <aside className="table-of-contents">
              <h3>Quick Navigation</h3>
              <nav>
                <ul>
                  <li><a href="#our-story">Our Story</a></li>
                  <li><a href="#our-mission">Our Mission</a></li>
                  <li><a href="#our-values">Our Values</a></li>
                  <li><a href="#our-journey">Our Journey</a></li>
                  <li><a href="#educational-philosophy">Educational Philosophy</a></li>
                  <li><a href="#contact">Get In Touch</a></li>
                </ul>
              </nav>
            </aside>

            {/* Main Content */}
            <div className="policy-sections">
              <section id="our-story" className="policy-section">
                <h2>Our Story</h2>
                <div className="section-content">
                  <div className="security-features">
                    <h3>From Confusion to Clarity</h3>
                    <p>
                      <strong>noobtobull was born from a simple observation:</strong> too many people 
                      feel overwhelmed by financial complexity. We believe everyone deserves 
                      access to clear, reliable financial tools that empower rather than confuse.
                    </p>
                  </div>

                  <p>
                    Founded in 2025 by Darshan, our journey began when we noticed many people 
  struggling with basic financial calculations. Existing tools were either too simple 
  or overly complex, often lacking proper educational context.
                  </p>

                  <p>
  noobtobull was created to provide clear, reliable tools that educate rather than confuse, 
  helping users worldwide build financial confidence.
</p>
                </div>
              </section>

              <section id="our-mission" className="policy-section">
                <h2>Our Mission & Vision</h2>
                <div className="section-content">
                  <h3>Our Mission</h3>
                  <p>
                    To make financial education accessible to everyone by offering easy-to-use, 
  accurate calculators and learning tools that help users understand key concepts 
  and make smarter financial decisions.
                  </p>

                  <h3>Our Vision</h3>
                  <p>
                    Our platform includes <a href="https://noobtobull.com" target="_blank" rel="noopener noreferrer">noobtobull.com</a> and its blog <a href="https://blog.noobtobull.com" target="_blank" rel="noopener noreferrer">blog.noobtobull.com</a>, providing educational resources for all levels of learners.
                  </p>

                  <div className="rights-grid">
                    <div className="right-item">
                      <h4>Education First</h4>
                      <p>Tools designed for learning, not just calculating</p>
                    </div>
                    <div className="right-item">
                      <h4>Accessibility</h4>
                      <p>Complex concepts made simple and approachable</p>
                    </div>
                    <div className="right-item">
                      <h4>Empowerment</h4>
                      <p>Building confidence through understanding</p>
                    </div>
                    <div className="right-item">
                      <h4>Innovation</h4>
                      <p>Continually improving our educational approach</p>
                    </div>
                  </div>
                </div>
              </section>

              <section id="our-values" className="policy-section">
                <h2>Our Values</h2>
                <div className="section-content">
                  <p>
                    These core values guide everything we do, from calculator development 
                    to user support and content creation.
                  </p>

                  <div className="values-grid">
                    {values.map((value, index) => (
                      <div key={index} className="value-item">
                        <div className="value-icon"><i class={value.icon}></i></div>
                        <div className="value-content">
                          <h4>{value.title}</h4>
                          <p>{value.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="security-features">
                    <h3>Educational Integrity</h3>
                    <p>
                      <strong>We never provide financial advice or recommendations.</strong> 
                      Our role is to educate and empower you to have more informed conversations 
                      with qualified financial professionals.
                    </p>
                  </div>
                </div>
              </section>

              <section id="our-journey" className="policy-section">
                <h2>Our Journey</h2>
                <div className="section-content">
                  <p>
                    From our founding to today, here are the key milestones in our journey 
                    to make financial education more accessible.
                  </p>

                  <div className="timeline">
                    {milestones.map((milestone, index) => (
                      <div key={index} className="timeline-item">
                        <div className="timeline-year">{milestone.year}</div>
                        <div className="timeline-content">
                          <h4>{milestone.title}</h4>
                          <p>{milestone.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="security-features">
                    <h3>Looking Ahead</h3>
                    <p>
                      <strong>Our journey continues with new calculators, improved educational 
                      content, and enhanced user experiences.</strong> We're committed to evolving 
                      with our users' needs and the changing financial landscape.
                    </p>
                  </div>
                </div>
              </section>

              <section id="educational-philosophy" className="policy-section">
                <h2>Educational Philosophy</h2>
                <div className="section-content">
                  <h3>Learning Through Doing</h3>
                  <p>
                    We believe that interactive learning through calculators helps build 
                    deeper understanding than passive reading alone. Our approach combines:
                  </p>

                  <div className="rights-grid">
                    <div className="right-item">
                      <h4>Interactive Tools</h4>
                      <p>Hands-on calculators that demonstrate financial principles</p>
                    </div>
                    <div className="right-item">
                      <h4>Clear Explanations</h4>
                      <p>Simple language that makes complex concepts accessible</p>
                    </div>
                    <div className="right-item">
                      <h4>Real Context</h4>
                      <p>Practical examples that show how calculations apply to real life</p>
                    </div>
                    <div className="right-item">
                      <h4>Progressive Learning</h4>
                      <p>Tools that grow with your understanding and confidence</p>
                    </div>
                  </div>

                  <h3>What Makes Us Different</h3>
                  <p>
                    Unlike many other financial websites, noobtobull focuses solely on education. 
  We do not sell products, manage investments, or provide personal advice, 
  ensuring complete objectivity and a learning-first experience.
                  </p>

                  <div className="security-features">
                    <h3>No Conflicts of Interest</h3>
                    <p>
                      <strong>We don't sell financial products or manage investments.</strong> 
                      This means our only incentive is to provide the best possible 
                      educational experience. Your learning is our success metric.
                    </p>
                  </div>
                </div>
              </section>

              <section id="contact" className="policy-section">
                <h2>Get In Touch</h2>
                <div className="section-content">
                  <p>
                    We love hearing from our users! Whether you have feedback, suggestions, 
                    or just want to share your learning journey, we're here to listen.
                  </p>

                  <div className="contact-info">
                    <div className="contact-item">
                      <strong>General Inquiries:</strong> support@noobtobull.com
                    </div>
                    <div className="contact-item">
                      <strong>Address:</strong> 2568 Madison Ave, League City, TX 77573
                    </div>
                  </div>

                  <div className="security-features">
                    <h3>Join Our Community</h3>
                    <p>
                      <strong>Your feedback shapes our platform.</strong> Thousands of our 
                      current features started as user suggestions. Help us continue to 
                      improve financial education for everyone.
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="policy-actions">
        <div className="container">
          <div className="actions-content">
            <h3>Start Your Financial Learning Journey</h3>
            <p>Explore our calculators and begin building your financial confidence today.</p>
            <div className="action-buttons">
              <a href="/ShortLongCalculator" className="btn btn-primary">Browse Calculators</a>
              <a href="/Contact" className="btn btn-secondary">Share Your Story</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;